module.exports = __webpack_public_path__ + "img/INVERSER_NOM_PRENOM.b61c076b.svg";